export default "__VITE_ASSET__CLL23DBF__"